import { Box } from '@rbilabs/universal-components';

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const ProductDetailFlowHeaderContainer = Box.withConfig({
  width: 'full',
  height: '$16',
  justifyContent: 'center',
  alignItems: 'center',
});
